<form #form="ngForm">
    <plex-int [autoFocus]="true" *ngIf="!soloValores" placeholder="Ingrese un valor entre 10 y 250"
                [(ngModel)]="registro.valor" (change)="emitChange()" name="talla" label="{{ registro.concepto.term }}"
                suffix="cm" [required]="esRequerido" min="10" max="250">
    </plex-int>

    <p *ngIf="soloValores && registro?.evoluciones?.length" class="readonly">
        <span>Talla</span> {{ registro.evoluciones[0].valor }} cm
    </p>

    <p *ngIf="soloValores && registro?.valor" class="readonly">
        <span>Talla</span> {{ registro.valor }} cm
    </p>

    <p *ngIf="soloValores && (!registro?.valor && !registro?.evoluciones?.length)" class="readonly">
        <span>Talla</span> sin valor
    </p>

    <p *ngIf="mensaje && mensaje.texto">
        <plex-badge type="{{mensaje.class}}">
            {{mensaje.texto}}
        </plex-badge>
    </p>
</form>